/**
 * シーンキー定数
 *
 * Phaserのシーン管理で使用する一意なキー文字列を定義。
 * 文字列リテラルのタイプミスを防ぎ、補完を効かせるために定数化する。
 */
export enum SceneKey {
  /** 起動シーン（アセットロード） */
  BOOT = 'BOOT',
  /** タイトル画面 */
  TITLE = 'TITLE',
  /** モード選択画面 */
  MODE_SELECT = 'MODE_SELECT',
  /** キャラ選択画面 */
  CHARACTER_SELECT = 'CHARACTER_SELECT',
  /** バトル画面 */
  BATTLE = 'BATTLE',
  /** リザルト画面 */
  RESULT = 'RESULT',
  /** 設定画面 */
  SETTINGS = 'SETTINGS',
  /** 難易度選択画面 */
  DIFFICULTY_SELECT = 'DIFFICULTY_SELECT',
  /** 戦績画面 */
  BATTLE_STATS = 'BATTLE_STATS',
  /** 対戦モード選択画面 */
  BATTLE_MODE_SELECT = 'BATTLE_MODE_SELECT',
  /** 対戦種別選択画面（対CPU/ローカル/観戦） */
  VERSUS_SELECT = 'VERSUS_SELECT',
  /** スプライトテスト画面（開発用） */
  SPRITE_TEST = 'SPRITE_TEST',
  /** サバイバルEXP割り振り画面 */
  SURVIVAL_EXP_ALLOCATION = 'SURVIVAL_EXP_ALLOCATION',
  /** サバイバルリザルト画面 */
  SURVIVAL_RESULT = 'SURVIVAL_RESULT',
  /** 大会設定画面 */
  TOURNAMENT_SETUP = 'TOURNAMENT_SETUP',
  /** 大会対戦表/ブラケット画面 */
  TOURNAMENT_BRACKET = 'TOURNAMENT_BRACKET',
  /** 大会結果画面 */
  TOURNAMENT_RESULT = 'TOURNAMENT_RESULT',
  /** AIキャラ作成・編集画面 */
  AI_CHARACTER_EDIT = 'AI_CHARACTER_EDIT',
  /** ステージ選択画面（キャンペーン） */
  STAGE_SELECT = 'STAGE_SELECT',
  /** 実績一覧画面 */
  ACHIEVEMENT = 'ACHIEVEMENT',
  /** デバッグ画面 */
  DEBUG = 'DEBUG',
}

/** 全シーンキーの配列（順序はシーン登録順） */
export const ALL_SCENE_KEYS: SceneKey[] = [
  SceneKey.BOOT,
  SceneKey.TITLE,
  SceneKey.MODE_SELECT,
  SceneKey.CHARACTER_SELECT,
  SceneKey.BATTLE,
  SceneKey.RESULT,
  SceneKey.SETTINGS,
  SceneKey.DIFFICULTY_SELECT,
  SceneKey.BATTLE_STATS,
  SceneKey.BATTLE_MODE_SELECT,
  SceneKey.VERSUS_SELECT,
  SceneKey.SPRITE_TEST,
  SceneKey.SURVIVAL_EXP_ALLOCATION,
  SceneKey.SURVIVAL_RESULT,
  SceneKey.TOURNAMENT_SETUP,
  SceneKey.TOURNAMENT_BRACKET,
  SceneKey.TOURNAMENT_RESULT,
  SceneKey.AI_CHARACTER_EDIT,
  SceneKey.STAGE_SELECT,
  SceneKey.ACHIEVEMENT,
  SceneKey.DEBUG,
];
